import { ShortLocaleEnum } from 'schema/locale';
import { numToFixed } from '../numToFixed';
import { pluralize } from '../pluralize';

export const getPrice = (
  symbol: string,
  price: number | string,
  digits: number = 2,
  rawPrice?: boolean
) => (rawPrice ? `${symbol}${price}` : `${symbol}${numToFixed(price, digits)}`);

export const getPriceMaybeFixed = (
  symbol: string,
  price: number | string,
  digits: number = 2,
  rawPrice?: boolean
) => {
  if (rawPrice) {
    return `${symbol}${price}`;
  }
  const fixedPrice = numToFixed(price, digits);
  const truncPrice = numToFixed(price, 0);
  if (Number(fixedPrice) !== Number(truncPrice)) {
    return `${symbol}${fixedPrice}`;
  }
  return `${symbol}${truncPrice}`;
};

export const getFrequency = (
  period: string,
  interval: string | number,
  language: ShortLocaleEnum = ShortLocaleEnum.de
) => {
  const periodUnit = period === 'days' ? 'day' : period;
  const frequencyUnit =
    language === ShortLocaleEnum.de ? `${interval} Tage` : pluralize(Number(interval), periodUnit);
  return frequencyUnit;
};
